import { useMemo } from "react"

export default function use3DViewer(viewerRef, id) {
  return useMemo(() => {
    return {
      send: (eventName, eventPayload) => {
        const viewer = viewerRef?.current || document.getElementById(id)

        if (!viewer) {
          console.error(`Viewer not initialized, error sending event ${eventName}`)
          return
        }
        viewer.contentWindow.postMessage(
          {
            event: eventName,
            payload: eventPayload, // Replace with your data
          },
          '*', // Specify the iframe origin
        )
      },
    }
  }, [id, viewerRef])
}
